import React, { useEffect } from 'react';
import { useStock } from '../../context/StockContext';

export default function StockAlerts() {
  const { alerts, fetchAll, markAlertsRead } = useStock();
  useEffect(() => { fetchAll(); }, []);

  const typeStyle = {
    low_stock: { bg:'#fee2e2', color:'#dc2626', icon:'⚠️', label:'Stock faible' },
    expiry:    { bg:'#fef3c7', color:'#d97706', icon:'📅', label:'Expiration' },
    system:    { bg:'#E6F1FB', color:'#0B3D6E', icon:'ℹ️', label:'Système' },
  };

  return (
    <div style={{ maxWidth:700, margin:'0 auto', padding:'1.5rem' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem' }}>
        <h1 style={{ fontSize:20, fontWeight:600 }}>Alertes stock</h1>
        <button onClick={()=>markAlertsRead('all')} style={{ background:'#f1f5f9', border:'1px solid #e2e8f0', padding:'7px 14px', borderRadius:8, fontSize:12, cursor:'pointer' }}>
          Tout marquer comme lu
        </button>
      </div>

      {alerts.length===0 ? (
        <div style={{ textAlign:'center', padding:'4rem', color:'#94a3b8', background:'#fff', borderRadius:12, border:'1px solid #e2e8f0' }}>
          <div style={{ fontSize:48, marginBottom:12 }}>✅</div>
          <div style={{ fontSize:15, fontWeight:500 }}>Aucune alerte active</div>
          <div style={{ fontSize:13, marginTop:6 }}>Votre stock est en bonne santé !</div>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
          {alerts.map(a => {
            const ts = typeStyle[a.type]||typeStyle.system;
            return (
              <div key={a._id} style={{ background:'#fff', border:`1px solid ${a.isRead?'#e2e8f0':ts.color+'40'}`, borderRadius:10, padding:'12px 16px', display:'flex', alignItems:'flex-start', gap:12, opacity:a.isRead?0.6:1, boxShadow:a.isRead?'none':'0 2px 8px rgba(0,0,0,0.08)' }}>
                <div style={{ width:36, height:36, borderRadius:9, background:ts.bg, display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, flexShrink:0 }}>{ts.icon}</div>
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:8 }}>
                    <div>
                      <span style={{ fontSize:11, fontWeight:600, color:ts.color, textTransform:'uppercase', letterSpacing:'0.5px' }}>{ts.label}</span>
                      <div style={{ fontSize:13, fontWeight:500, marginTop:2 }}>{a.message}</div>
                    </div>
                    <div style={{ fontSize:11, color:'#94a3b8', whiteSpace:'nowrap' }}>{new Date(a.createdAt).toLocaleDateString('fr-FR')}</div>
                  </div>
                </div>
                {!a.isRead && (
                  <button onClick={()=>markAlertsRead(a._id)} style={{ background:'none', border:'none', color:'#94a3b8', fontSize:11, cursor:'pointer', flexShrink:0 }}>✓ Lu</button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

